import { BaseClient } from '../client';

export interface PushBroadcastPayload {
	titulo: string;
	mensagem: string;
	status: 'todos' | 'ativos' | 'inativos';
}

export interface PushBroadcastResponse {
	success: boolean;
	enviados?: number;
	falhas?: number;
	total?: number;
	message?: string;
}

export const postPushBroadcast = async (requestBody: PushBroadcastPayload) => {
	try {
		const response = await BaseClient.post<PushBroadcastResponse>(
			'v2/Notification/Post/PushNotificationBroadcast',
			requestBody
		);
		return response;
	} catch (error: unknown) {
		console.error('error', error);
	}
};
